import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsReport extends Layout {
    checkboxIncludeOpenCreadit: Checkbox;
    checkboxPageBreak: Checkbox;
    checkboxPrintBol: Checkbox;
    checkboxPrintExtend: Checkbox;
    excludabletextboxCategory: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxNextActionCode: ExcludableTextbox;
    sourceCollectionReport: DataSource;
    switchIncCallHist: Switch;
    switchSwitchReportType: Switch;
    textboxAssignedUser: Textbox;
    textboxCallHistStatrtDate: Textbox;
    textboxCutoffAgeDate: Textbox;
    textboxIncludeCustomers: Textbox;
    textboxNextactionDate: Textbox;
    textboxPastDue: Textbox;
    textboxReportBy: Textbox;
    textboxShortPaidInvoice: Textbox;
    textboxSortBy: Textbox;
}
